import React, { useState, useEffect } from 'react';
import { FaCheckCircle, FaStar, FaCrown, FaArrowLeft, FaGripVertical, FaPlus, FaTimes, FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export const BUILDER_DEPENDENCIES = {
  'page_wf_takeaway': [
    { moduleId: 'mod_pos_dashboard', pageId: null },
    { moduleId: 'mod_pos_billing', pageId: null },
    { moduleId: 'mod_inventory_mgmt', pageId: null },
    { moduleId: 'mod_admin_dashboard', pageId: null }
  ],
  'page_wf_kiosk': [
    { moduleId: 'mod_pos_dashboard', pageId: null },
    { moduleId: 'mod_pos_billing', pageId: null },
    { moduleId: 'mod_inventory_mgmt', pageId: null },
    { moduleId: 'mod_admin_dashboard', pageId: null }
  ],
  'page_wf_dinein': [
    { moduleId: 'mod_table_mgmt', pageId: null },
    { moduleId: 'mod_pos_dashboard', pageId: null },
    { moduleId: 'mod_pos_billing', pageId: null },
    { moduleId: 'mod_inventory_mgmt', pageId: null },
    { moduleId: 'mod_admin_dashboard', pageId: null }
  ],
  'page_wf_online': [
    { moduleId: 'mod_vehicle_mgmt', pageId: null },
    { moduleId: 'mod_hr_payroll', pageId: null },
    { moduleId: 'mod_order_tracking', pageId: null },
    { moduleId: 'mod_customer_mgmt', pageId: null },
    { moduleId: 'mod_pos_dashboard', pageId: null },
    { moduleId: 'mod_pos_billing', pageId: null },
    { moduleId: 'mod_admin_dashboard', pageId: null }
  ],
  'mod_pos_billing': [
    { moduleId: 'mod_settings', pageId: null },
    { moduleId: 'mod_reports', pageId: null }
  ],
  'page_posb_open': [{ moduleId: 'mod_settings', pageId: null }, { moduleId: 'mod_reports', pageId: null }],
  'page_posb_close': [{ moduleId: 'mod_settings', pageId: null }, { moduleId: 'mod_reports', pageId: null }],
  'page_posb_history': [{ moduleId: 'mod_settings', pageId: null }, { moduleId: 'mod_reports', pageId: null }],
  'page_posb_cash': [{ moduleId: 'mod_settings', pageId: null }, { moduleId: 'mod_reports', pageId: null }],
  'page_posb_card': [{ moduleId: 'mod_settings', pageId: null }, { moduleId: 'mod_reports', pageId: null }],
  'page_posb_upi': [{ moduleId: 'mod_settings', pageId: null }, { moduleId: 'mod_reports', pageId: null }],
  'mod_kitchen_mgmt': [
    { moduleId: 'mod_order_tracking', pageId: null },
    { moduleId: 'mod_inventory_mgmt', pageId: null }
  ],
  'page_km_active': [
    { moduleId: 'mod_order_tracking', pageId: null }
  ],
  'mod_purchase_mgmt': [
    { moduleId: 'mod_inventory_mgmt', pageId: null },
    { moduleId: 'mod_settings', pageId: null }
  ],
  'mod_table_mgmt': [
    { moduleId: 'mod_customer_mgmt', pageId: null }
  ],
  'mod_reports': [
    { moduleId: 'mod_settings', pageId: null }
  ],
  'page_rep_inv': [{ moduleId: 'mod_settings', pageId: null }],
  'page_rep_sal': [{ moduleId: 'mod_settings', pageId: null }],
  'page_rep_kanban': [{ moduleId: 'mod_settings', pageId: null }],
  'page_rep_trip': [{ moduleId: 'mod_settings', pageId: null }],
  'mod_notifications': [
    { moduleId: 'mod_settings', pageId: null }
  ],
  'page_notif_main': [{ moduleId: 'mod_settings', pageId: null }],
  'page_notif_voice': [{ moduleId: 'mod_settings', pageId: null }],
  'page_set_bkp': [{ moduleId: 'mod_settings', pageId: null }],
  'page_role_perm': [
    { moduleId: 'mod_hr_payroll', pageId: null }
  ],
  'mod_hr_payroll': [
    { moduleId: 'mod_role_mgmt', pageId: null }
  ],
  'mod_customer_mgmt': [
    { moduleId: 'mod_address_mgmt', pageId: null }
  ],
  'page_hr_delpersons': [
    { moduleId: 'mod_vehicle_mgmt', pageId: null }
  ],
  'mod_multi_branch': [
    { moduleId: 'mod_settings', pageId: null }
  ],
  'page_im_combo': [
    { moduleId: 'mod_inventory_mgmt', pageId: 'page_im_offers_display' }
  ],
  'page_im_offers_display': [
    { moduleId: 'mod_inventory_mgmt', pageId: 'page_im_combo' }
  ],
  'page_im_stock_balance': [
    { moduleId: 'mod_inventory_mgmt', pageId: null }
  ],
  'page_im_stock_ledger': [
    { moduleId: 'mod_inventory_mgmt', pageId: null }
  ]
};

const RestaurantPlan = () => {
  const navigate = useNavigate();

  const basePlans = [
    {
      name: 'Basic Plan',
      basePrice: 0,
      desc: 'Ideal for single coffee shops or QSR counters. Includes Billing & Items.',
      icon: <FaCheckCircle style={{ color: '#3498db' }} />,
      bg: 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)',
      border: '#bdc3c7',
      headerColor: '#34495e'
    },
    {
      name: 'Silver Plan',
      basePrice: 0,
      desc: 'Adds Purchase management, tables layout, and kitchen KOT. Best for full-service cafes.',
      icon: <FaStar style={{ color: '#f1c40f' }} />,
      bg: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
      border: '#e67e22',
      featured: true,
      headerColor: '#d35400'
    },
    {
      name: 'Gold Plan',
      basePrice: 0,
      desc: 'Fully featured multi-tenant setup with Delivery integrations, unlimited branches.',
      icon: <FaCrown style={{ color: '#9b59b6' }} />,
      bg: 'linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)',
      border: '#9b59b6',
      headerColor: '#8e44ad'
    }
  ];

  // Master List with Nested Pages
  const initialModules = [
    {
      id: 'mod_workflows', name: 'Workflows & Experience', price: 40, isExpanded: false,
      pages: [
        { id: 'page_wf_takeaway', name: 'Takeaway', price: 0 },
        { id: 'page_wf_dinein', name: 'Dine In', price: 15 },
        { id: 'page_wf_online', name: 'Online Delivery', price: 25 },
        { id: 'page_wf_kiosk', name: 'Kiosk System', price: 20 }
      ]
    },
    {
      id: 'mod_pos_dashboard', name: 'POS Dashboard', price: 0, isExpanded: false,
      pages: [
        { id: 'page_posd_home', name: 'Home Dashboard', price: 0 },
        { id: 'page_posd_front', name: 'Front Page', price: 0 },
        { id: 'page_posd_bal', name: 'POS Balance', price: 0 }
      ]
    },
    {
      id: 'mod_pos_billing', name: 'POS Billing', price: 0, isExpanded: false,
      pages: [
        { id: 'page_posb_open', name: 'Opening Entry', price: 0 },
        { id: 'page_posb_close', name: 'Closing Entry', price: 0 },
        { id: 'page_posb_history', name: 'Session History', price: 0 },
        { id: 'page_posb_cash', name: 'Cash Payment', price: 0 },
        { id: 'page_posb_card', name: 'Card Payment', price: 0 },
        { id: 'page_posb_upi', name: 'UPI Payment', price: 0 }
      ]
    },
    {
      id: 'mod_table_mgmt', name: 'Table Management', price: 0, isExpanded: false,
      pages: [
        { id: 'page_tm_table', name: 'Table Page', price: 0 },
        { id: 'page_tm_add', name: 'Add Table', price: 0 },
        { id: 'page_tm_book', name: 'Table Booking', price: 0 }
      ]
    },
    {
      id: 'mod_kitchen_mgmt', name: 'Kitchen Management', price: 0, isExpanded: false,
      pages: [
        { id: 'page_km_kitchen', name: 'Kitchen Page', price: 0 },
        { id: 'page_km_add', name: 'Add Kitchen', price: 0 },
        { id: 'page_km_active', name: 'Active Orders', price: 0 }
      ]
    },
    {
      id: 'mod_customer_mgmt', name: 'Customer Management', price: 15, isExpanded: false,
      pages: [
        { id: 'page_cm_list', name: 'Customer List', price: 0 },
        { id: 'page_cm_create', name: 'Create Customer', price: 0 },
        { id: 'page_cm_group', name: 'Customer Group', price: 0 }
      ]
    },
    {
      id: 'mod_inventory_mgmt', name: 'Inventory Management', price: 20, isExpanded: false,
      pages: [
        { id: 'page_im_list', name: 'Items List', price: 0 },
        { id: 'page_im_create', name: 'Create Item', price: 0 },
        { id: 'page_im_hidden', name: 'Hidden Items', price: 0 },
        { id: 'page_im_grplist', name: 'Item Group List', price: 0 },
        { id: 'page_im_addgrp', name: 'Add Item Group', price: 0 },
        { id: 'page_im_variant', name: 'Create Variant', price: 0 },
        { id: 'page_im_ingred', name: 'Add Ingredients & Nutrition', price: 0 },
        { id: 'page_im_combo', name: 'Combo Offer', price: 0 },
        { id: 'page_im_offers_display', name: 'Offers Display', price: 0 },
        { id: 'page_im_toppings', name: 'Toppings', price: 0 },
        { id: 'page_im_menu_timings', name: 'Menu Timings', price: 0 },
        { id: 'page_im_active_plans', name: 'Active Plans', price: 0 },
        { id: 'page_im_stock_balance', name: 'Stock Balance', price: 0 },
        { id: 'page_im_stock_ledger', name: 'Stock Ledger', price: 0 }
      ]
    },
    {
      id: 'mod_purchase_mgmt', name: 'Purchase Management', price: 20, isExpanded: false,
      pages: [
        { id: 'page_pm_sup', name: 'Suppliers', price: 0 },
        { id: 'page_pm_grplist', name: 'Supplier Group List', price: 0 },
        { id: 'page_pm_items', name: 'Items List', price: 0 },
        { id: 'page_pm_order', name: 'Purchase Order', price: 0 },
        { id: 'page_pm_rect', name: 'Purchase Receipt', price: 0 },
        { id: 'page_pm_inv', name: 'Purchase Invoice', price: 0 },
        { id: 'page_pm_rep', name: 'Purchase Reports', price: 0 }
      ]
    },
    {
      id: 'mod_hr_payroll', name: 'HR & Payroll', price: 0, isExpanded: false,
      pages: [
        { id: 'page_hr_addemp', name: 'Add Employee', price: 0 },
        { id: 'page_hr_emplist', name: 'Employee List', price: 0 },
        { id: 'page_hr_delpersons', name: 'Delivery Persons', price: 0 },
        { id: 'page_delivery_panel', name: 'Delivery Panel', price: 0 },
        { id: 'page_hr_empdet', name: 'Employee Details', price: 0 },
        { id: 'page_hr_empdesig', name: 'Employee Designations', price: 0 },
        { id: 'page_hr_emptypes', name: 'Employee Types', price: 0 },
        { id: 'page_hr_empdepts', name: 'Employee Departments', price: 0 },
        { id: 'page_hr_att', name: 'Attendance', price: 0 },
        { id: 'page_hr_attview', name: 'Attendance View', price: 0 },
        { id: 'page_hr_salslip', name: 'Salary Slip', price: 0 },
        { id: 'page_hr_salrect', name: 'Salary Receipt List', price: 0 },
        { id: 'page_hr_lvtype', name: 'Leave Type', price: 0 },
        { id: 'page_hr_lvalloc', name: 'Leave Allocation', price: 0 },
        { id: 'page_hr_lvapply', name: 'Leave Apply', price: 0 },
        { id: 'page_hr_schmas', name: 'Schedule Master', price: 0 },
        { id: 'page_hr_schass', name: 'Schedule Assign Employee', price: 0 },
        { id: 'page_hr_roaster', name: 'Roaster', price: 0 },
        { id: 'page_hr_users', name: 'Users', price: 0 },
        { id: 'page_hr_hollist', name: 'Holiday List', price: 0 },
        { id: 'page_hr_extdoc', name: 'Extended DocType', price: 0 }
      ]
    },
    {
      id: 'mod_vehicle_mgmt', name: 'Vehicle Management', price: 0, isExpanded: false,
      pages: [
        { id: 'page_veh_mgmt', name: 'Vehicle Management', price: 0 }
      ]
    },
    {
      id: 'mod_address_mgmt', name: 'Address Management', price: 0, isExpanded: false,
      pages: [
        { id: 'page_add_struc', name: 'Address Structure', price: 0 }
      ]
    },
    {
      id: 'mod_reports', name: 'Reports', price: 15, isExpanded: false,
      pages: [
        { id: 'page_rep_inv', name: 'Sales Invoice', price: 0 },
        { id: 'page_rep_sal', name: 'Sales Report', price: 0 },
        { id: 'page_rep_kanban', name: 'Sales Kanban', price: 0 },
        { id: 'page_rep_trip', name: 'Trip Report', price: 0 }
      ]
    },
    {
      id: 'mod_settings', name: 'Settings', price: 15, isExpanded: false,
      pages: [
        { id: 'page_set_sys', name: 'System Settings', price: 0 },
        { id: 'page_set_email', name: 'Email Settings', price: 0 },
        { id: 'page_set_wa', name: 'WhatsApp Settings', price: 0 },
        { id: 'page_set_print', name: 'Print Settings', price: 0 },
        { id: 'page_set_bkp', name: 'Backups', price: 0 },
        { id: 'page_set_imp', name: 'Advanced Import', price: 0 },
        { id: 'page_set_work', name: 'Working Days', price: 0 },
        { id: 'page_set_doc', name: 'DocType Management', price: 0 },
        { id: 'page_set_tax', name: 'Tax Master', price: 0 }
      ]
    },
    {
      id: 'mod_multi_branch', name: 'Multi Branch Support', price: 50, isExpanded: false,
      pages: [
        { id: 'page_mb_tenants', name: 'Manage Tenants', price: 0 },
        { id: 'page_mb_comp', name: 'Manage Companies', price: 0 },
        { id: 'page_mb_branch', name: 'Manage Branches', price: 0 },
        { id: 'page_mb_compdet', name: 'Company Details', price: 0 }
      ]
    },
    {
      id: 'mod_auth', name: 'Authentication', price: 10, isExpanded: false,
      pages: [
        { id: 'page_auth_log', name: 'Login', price: 0 },
        { id: 'page_auth_reg', name: 'Register', price: 0 }
      ]
    },
    {
      id: 'mod_role_mgmt', name: 'Role Management', price: 0, isExpanded: false,
      pages: [
        { id: 'page_role_perm', name: 'Role Permissions', price: 0 }
      ]
    },
    {
      id: 'mod_notifications', name: 'Notifications & Voice', price: 0, isExpanded: false,
      pages: [
        { id: 'page_notif_main', name: 'Notifications', price: 0 },
        { id: 'page_notif_voice', name: 'Voice Support', price: 0 }
      ]
    },
    {
      id: 'mod_order_tracking', name: 'Order Tracking', price: 0, isExpanded: false,
      pages: [
        { id: 'page_trk_act', name: 'Active Orders', price: 0 },
        { id: 'page_trk_live', name: 'Live Tracking', price: 0 }
      ]
    },
    {
      id: 'mod_admin_dashboard', name: 'Admin Dashboard', price: 25, isExpanded: false,
      pages: [
        { id: 'page_ad_dash', name: 'Dashboard', price: 0 },
        { id: 'page_ad_pan', name: 'Admin Panel', price: 0 },
        { id: 'page_ad_main', name: 'Main Page', price: 0 }
      ]
    },
    {
      id: 'mod_rewards_mgmt', name: 'Rewards Management', price: 15, isExpanded: false,
      pages: [
        { id: 'page_rew_rules', name: 'Reward Rules', price: 0 },
        { id: 'page_rew_create', name: 'Create Reward', price: 0 },
        { id: 'page_rew_set', name: 'Reward Settings', price: 0 }
      ]
    }
  ];

  const [availableModules, setAvailableModules] = useState(initialModules);

  const [planItems, setPlanItems] = useState({
    'Basic Plan': [],
    'Silver Plan': [],
    'Gold Plan': []
  });

  const [planConfigs, setPlanConfigs] = useState({
    'Basic Plan': { pricingTiers: [] },
    'Silver Plan': { pricingTiers: [] },
    'Gold Plan': { pricingTiers: [] }
  });

  const [pendingDrop, setPendingDrop] = useState(null);

  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        const response = await fetch('/api/admin/plan_config');
        if (response.ok) {
          const data = await response.json();
          if (data['MASTER_PALETTE']) {
            const masterItems = Array.isArray(data['MASTER_PALETTE']) ? data['MASTER_PALETTE'] : data['MASTER_PALETTE'].items;
            const mergedPalette = initialModules.map(baseMod => {
              const fetchedMod = masterItems.find(m => m.id === baseMod.id);
              if (fetchedMod) {
                const mergedPages = baseMod.pages ? baseMod.pages.map(basePage => {
                  const fetchedPage = fetchedMod.pages?.find(p => p.id === basePage.id);
                  return fetchedPage ? fetchedPage : basePage;
                }) : [];
                return { ...fetchedMod, pages: mergedPages, isExpanded: false };
              }
              return { ...baseMod, isExpanded: false };
            });
            setAvailableModules(mergedPalette);
            delete data['MASTER_PALETTE'];
          }

          const newPlanItems = {};
          const newPlanConfigs = {};

          Object.keys(data).forEach(key => {
            const itemData = data[key];
            if (Array.isArray(itemData)) {
              newPlanItems[key] = itemData;
              newPlanConfigs[key] = { pricingTiers: [] };
            } else {
              newPlanItems[key] = itemData.items || [];
              newPlanConfigs[key] = {
                pricingTiers: itemData.pricingTiers || []
              };
            }
          });

          setPlanItems(prev => ({ ...prev, ...newPlanItems }));
          setPlanConfigs(prev => ({ ...prev, ...newPlanConfigs }));
        }
      } catch (error) {
        console.error("Failed to load plan configs", error);
      }
    };
    fetchConfigs();
  }, []);

  const handleSavePlan = async (planName) => {
    try {
      const items = planItems[planName];
      const config = planConfigs[planName] || { pricingTiers: [] };
      const currentItems = planItems[planName];

      const savePayload = {
        plan_name: planName,
        items: currentItems,
        config: {
          pricingTiers: config.pricingTiers || []
        }
      };
      const response = await fetch('/api/admin/plan_config', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(savePayload)
      });
      if (response.ok) {
        alert(`${planName} saved successfully!`);
      } else {
        alert(`Failed to save ${planName}.`);
      }
    } catch (error) {
      console.error("Save error", error);
      alert(`Error saving ${planName}.`);
    }
  };

  const handleSavePalette = async () => {
    try {
      const response = await fetch('/api/admin/plan_config', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          plan_name: 'MASTER_PALETTE',
          items: availableModules
        })
      });
      if (response.ok) {
        alert(`Palette saved successfully!`);
      } else {
        alert(`Failed to save Palette.`);
      }
    } catch (error) {
      console.error("Save error", error);
      alert(`Error saving Palette.`);
    }
  };

  const getPlanPrice = (planName, basePrice) => {
    const itemsInPlan = planItems[planName] || [];
    const extraCost = itemsInPlan.reduce((sum, item) => {
      // item.price is already the sum of child pages if it's a parent,
      // so we just add item.price directly. No double counting.
      return sum + Number(item.price || 0);
    }, 0);
    return basePrice + extraCost;
  };

  // Toggle expansion of parent modules in the left sidebar
  const toggleExpand = (modId) => {
    setAvailableModules(prev => prev.map(m =>
      m.id === modId ? { ...m, isExpanded: !m.isExpanded } : m
    ));
  };

  // Handle manual price changes in the sidebar
  const handlePriceChange = (modId, pageId, newPrice) => {
    const val = newPrice === '' ? 0 : Number(newPrice);

    setAvailableModules(prev => prev.map(m => {
      if (m.id === modId) {
        if (!pageId) {
          // Updating parent price
          return { ...m, price: val };
        } else {
          // Updating child page price
          const updatedPages = m.pages.map(p => p.id === pageId ? { ...p, price: val } : p);
          // Automatically sum up child prices for the parent module
          const newParentPrice = updatedPages.reduce((sum, p) => sum + Number(p.price || 0), 0);
          return { ...m, pages: updatedPages, price: newParentPrice };
        }
      }
      return m;
    }));
  };

  // --- Dependency Resolvers ---
  const getMissingDependencies = (itemId, targetPlanItems) => {
    let missing = [];
    const checkQueue = [itemId];
    const checked = new Set();
    const simulatedPlan = JSON.parse(JSON.stringify(targetPlanItems));

    const existsInSimulated = (dep) => {
      const mod = simulatedPlan.find(m => m.id === dep.moduleId);
      if (!mod) return false;
      if (dep.pageId) {
        return mod.pages && mod.pages.some(p => p.id === dep.pageId);
      }
      return true;
    };

    const addToSimulated = (dep) => {
      const mod = simulatedPlan.find(m => m.id === dep.moduleId);
      if (!mod) {
        if (dep.pageId) {
          simulatedPlan.push({ id: dep.moduleId, pages: [{ id: dep.pageId }] });
        } else {
          simulatedPlan.push({ id: dep.moduleId, pages: [] });
        }
      } else if (dep.pageId) {
        if (!mod.pages) mod.pages = [];
        if (!mod.pages.some(p => p.id === dep.pageId)) {
          mod.pages.push({ id: dep.pageId });
        }
      }
    };

    while (checkQueue.length > 0) {
      const currentId = checkQueue.shift();
      if (checked.has(currentId)) continue;
      checked.add(currentId);

      const deps = BUILDER_DEPENDENCIES[currentId] || [];
      deps.forEach(d => {
        if (!existsInSimulated(d)) {
          const alreadyMissing = missing.find(m => m.moduleId === d.moduleId && m.pageId === d.pageId);
          if (!alreadyMissing) {
            missing.push(d);
          }
          addToSimulated(d);
          checkQueue.push(d.pageId || d.moduleId);
        }
      });
    }
    return missing;
  };

  const getDependenciesOf = (itemId) => {
    let deps = [];
    let queue = [itemId];
    let checked = new Set();
    while (queue.length > 0) {
      let curr = queue.shift();
      if (checked.has(curr)) continue;
      checked.add(curr);
      let currDeps = BUILDER_DEPENDENCIES[curr] || [];
      currDeps.forEach(d => {
        if (!deps.some(existing => existing.moduleId === d.moduleId && existing.pageId === d.pageId)) {
          deps.push(d);
        }
        queue.push(d.pageId || d.moduleId);
      });
    }
    return deps;
  };

  const getRequiredDependencies = (planList) => {
    let allRequired = [];
    planList.forEach(item => {
      const queue = [item.id];
      if (item.pages) {
        item.pages.forEach(p => queue.push(p.id));
      }

      const checked = new Set();
      while (queue.length > 0) {
        const curr = queue.shift();
        if (checked.has(curr)) continue;
        checked.add(curr);

        const deps = BUILDER_DEPENDENCIES[curr] || [];
        deps.forEach(d => {
          if (!allRequired.some(existing => existing.moduleId === d.moduleId && existing.pageId === d.pageId)) {
            allRequired.push(d);
          }
          queue.push(d.pageId || d.moduleId);
        });
      }
    });
    return allRequired;
  };

  const cleanUnusedDependencies = (planList, removedItemId) => {
    const removedDeps = getDependenciesOf(removedItemId);
    if (removedDeps.length === 0) return planList;

    const remainingRequired = getRequiredDependencies(planList);
    let updatedList = JSON.parse(JSON.stringify(planList));

    removedDeps.forEach(d => {
      const isStillNeeded = remainingRequired.some(r => r.moduleId === d.moduleId && r.pageId === d.pageId);
      if (!isStillNeeded) {
        if (d.pageId) {
          updatedList = updatedList.map(mod => {
            if (mod.id === d.moduleId && mod.pages) {
              mod.pages = mod.pages.filter(p => p.id !== d.pageId);
            }
            return mod;
          }).filter(mod => !(mod.id === d.moduleId && (!mod.pages || mod.pages.length === 0)));
        } else {
          updatedList = updatedList.filter(mod => mod.id !== d.moduleId);
        }
      }
    });

    // recalculate prices
    updatedList = updatedList.map(mod => {
      if (mod.pages && mod.pages.length > 0) {
        mod.price = mod.pages.reduce((sum, p) => sum + Number(p.price || 0), 0);
      }
      return mod;
    });

    return updatedList;
  };

  // --- Drag and Drop Handlers ---
  const handleDragStart = (e, itemPayload, sourcePlan) => {
    e.dataTransfer.setData('itemPayload', JSON.stringify(itemPayload));
    e.dataTransfer.setData('sourcePlan', sourcePlan); // 'available' or planName
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.transform = 'scale(1.02)';
    e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
  };

  const handleDragLeave = (e) => {
    e.currentTarget.style.transform = 'scale(1)';
    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.05)';
  };

  const handleDrop = (e, targetPlan, targetIndex = null) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.currentTarget === e.target) {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.05)';
    }

    const payloadStr = e.dataTransfer.getData('itemPayload');
    const sourcePlan = e.dataTransfer.getData('sourcePlan');

    if (!payloadStr) return;

    const item = JSON.parse(payloadStr);

    // If target is available, it means we drag OUT of a plan to delete it
    if (targetPlan === 'available') {
      if (sourcePlan !== 'available') {
        handleRemoveFromPlan(item.id, sourcePlan);
      }
      return;
    }

    // Handle reordering within the SAME plan
    if (sourcePlan === targetPlan) {
      if (targetIndex === null) return; // Dropped on the container, not on an item

      setPlanItems(prev => {
        const list = [...prev[targetPlan]];
        const currentIndex = list.findIndex(i => i.id === item.id);
        if (currentIndex === -1 || currentIndex === targetIndex) return prev;

        list.splice(currentIndex, 1);
        list.splice(targetIndex, 0, item);

        return {
          ...prev,
          [targetPlan]: list
        };
      });
      return;
    }

    // Add to target plan (from another plan or palette)
    const exists = planItems[targetPlan].find(i => i.id === item.id);
    if (exists) return; // Do nothing if it's already there

    // Check for dependencies recursively
    const missingDependencies = getMissingDependencies(item.id, planItems[targetPlan]);

    if (missingDependencies.length > 0) {
      const selectableDependencies = missingDependencies.map(d => ({ ...d, checked: true }));
      setPendingDrop({ item, sourcePlan, targetPlan, targetIndex, missingDependencies: selectableDependencies });
      return; // Pause execution for modal
    }

    executeDrop(item, sourcePlan, targetPlan, targetIndex, []);
  };

  const executeDrop = (item, sourcePlan, targetPlan, targetIndex, autoDependencies = []) => {
    setPlanItems(prev => {
      let newSourceList = prev[sourcePlan];
      if (sourcePlan !== 'available') {
        newSourceList = prev[sourcePlan].filter(i => i.id !== item.id);
        newSourceList = cleanUnusedDependencies(newSourceList, item.id);
      }

      const newTargetList = [...prev[targetPlan]];

      if (targetIndex !== null) {
        newTargetList.splice(targetIndex, 0, item);
      } else {
        newTargetList.push(item);
      }

      // Inject dependencies safely
      autoDependencies.forEach(dep => {
        const fullMod = availableModules.find(m => m.id === dep.moduleId);
        if (!fullMod) return;

        const modIndexInTarget = newTargetList.findIndex(m => m.id === dep.moduleId);

        if (modIndexInTarget === -1) {
          if (dep.pageId) {
            const fullPage = fullMod.pages.find(p => p.id === dep.pageId);
            if (fullPage) {
              newTargetList.push({
                ...fullMod,
                isParent: true,
                pages: [fullPage],
                price: Number(fullPage.price || 0)
              });
            }
          } else {
            newTargetList.push({
              ...fullMod,
              isParent: true
            });
          }
        } else {
          if (dep.pageId) {
            const fullPage = fullMod.pages.find(p => p.id === dep.pageId);
            const targetMod = newTargetList[modIndexInTarget];
            if (fullPage && targetMod.pages && !targetMod.pages.find(p => p.id === dep.pageId)) {
              const updatedPages = [...targetMod.pages, fullPage];
              newTargetList[modIndexInTarget] = {
                ...targetMod,
                isParent: true,
                pages: updatedPages,
                price: updatedPages.reduce((sum, p) => sum + Number(p.price || 0), 0)
              };
            }
          }
        }
      });

      return {
        ...prev,
        ...(sourcePlan !== 'available' && { [sourcePlan]: newSourceList }),
        [targetPlan]: newTargetList
      };
    });
  };

  const confirmDrop = (addDependencies) => {
    if (!pendingDrop) return;

    if (addDependencies) {
      const selectedDeps = pendingDrop.missingDependencies.filter(d => d.checked);
      executeDrop(
        pendingDrop.item,
        pendingDrop.sourcePlan,
        pendingDrop.targetPlan,
        pendingDrop.targetIndex,
        selectedDeps
      );
    }
    // If cancelled, we abort the drop completely to ensure plans don't break.
    setPendingDrop(null);
  };

  const handleRemoveFromPlan = (itemId, planName) => {
    setPlanItems(prev => {
      let updatedList = prev[planName].filter(i => i.id !== itemId);
      updatedList = cleanUnusedDependencies(updatedList, itemId);
      return {
        ...prev,
        [planName]: updatedList
      };
    });
  };

  const handleRemovePageFromPlan = (planName, parentId, pageId) => {
    setPlanItems(prev => {
      let planList = prev[planName].map(item => {
        if (item.id === parentId && item.pages) {
          const updatedPages = item.pages.filter(p => p.id !== pageId);
          const newPrice = updatedPages.reduce((sum, p) => sum + Number(p.price || 0), 0);
          return { ...item, pages: updatedPages, price: newPrice };
        }
        return item;
      });

      planList = planList.filter(item => {
        if (item.id === parentId && (!item.pages || item.pages.length === 0)) {
          return false;
        }
        return true;
      });

      planList = cleanUnusedDependencies(planList, pageId);

      return { ...prev, [planName]: planList };
    });
  };

  return (
    <div style={{ padding: '30px', backgroundColor: '#f0f4f8', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>

      {/* Dependency Confirmation Modal */}
      {pendingDrop && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(2, 6, 23, 0.7)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(12px)', padding: '20px' }}>
          <div style={{
            background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
            padding: '35px 30px',
            borderRadius: '24px',
            width: '100%',
            maxWidth: '500px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Top Accent */}
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '5px', background: 'linear-gradient(90deg, #f59e0b, #ef4444)' }}></div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '25px' }}>
              <div style={{ width: '48px', height: '48px', borderRadius: '16px', background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2), rgba(239, 68, 68, 0.2))', border: '1px solid rgba(245, 158, 11, 0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: '24px' }}>⚠️</span>
              </div>
              <div>
                <h3 style={{ margin: '0 0 5px 0', color: '#0f172a', fontSize: '1.4rem', fontWeight: '800', letterSpacing: '-0.5px' }}>Missing Dependencies</h3>
                <p style={{ margin: 0, color: '#64748b', fontSize: '0.85rem' }}>Auto-include required modules</p>
              </div>
            </div>

            <div style={{ background: '#f1f5f9', borderRadius: '16px', padding: '20px', marginBottom: '25px', border: '1px solid #e2e8f0' }}>
              <p style={{ color: '#334155', fontSize: '0.95rem', margin: '0 0 15px 0', lineHeight: '1.6' }}>
                Adding <strong>{pendingDrop.item.name}</strong> to this plan requires the following modules to function correctly:
              </p>
              <ul style={{ margin: 0, paddingLeft: '0', listStyleType: 'none', color: '#b45309', fontSize: '0.9rem', lineHeight: '1.5', fontWeight: '600' }}>
                {pendingDrop.missingDependencies.map((dep, idx) => {
                  const mod = availableModules.find(m => m.id === dep.moduleId);
                  let name = mod ? mod.name : dep.moduleId;
                  if (dep.pageId && mod && mod.pages) {
                    const page = mod.pages.find(p => p.id === dep.pageId);
                    if (page) name += ` (${page.name})`;
                  } else if (!dep.pageId && mod && mod.pages && mod.pages.length > 0) {
                    const pageNames = mod.pages.map(p => p.name).join(', ');
                    name += ` [Includes: ${pageNames}]`;
                  }
                  return (
                    <li key={idx} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '6px', borderRadius: '8px', transition: 'background-color 0.2s' }}
                      onMouseOver={e => e.currentTarget.style.backgroundColor = '#e2e8f0'}
                      onMouseOut={e => e.currentTarget.style.backgroundColor = 'transparent'}
                      onClick={() => {
                        setPendingDrop(prev => {
                          const newDeps = [...prev.missingDependencies];
                          newDeps[idx].checked = !newDeps[idx].checked;
                          return { ...prev, missingDependencies: newDeps };
                        });
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={dep.checked}
                        onChange={() => { }}
                        style={{ cursor: 'pointer', width: '18px', height: '18px', accentColor: '#ea580c' }}
                      />
                      <span style={{ userSelect: 'none' }}>{name}</span>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              <button onClick={() => confirmDrop(false)} style={{ flex: 1, padding: '16px', background: 'transparent', color: '#64748b', border: '1px solid #cbd5e1', borderRadius: '14px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s', fontSize: '1rem' }} onMouseOver={e => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.color = '#334155'; }} onMouseOut={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#64748b'; }}>
                Cancel Drop
              </button>
              <button onClick={() => confirmDrop(true)} style={{ flex: 1.5, padding: '16px', background: 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)', color: '#ffffff', border: 'none', borderRadius: '14px', fontWeight: '700', cursor: 'pointer', boxShadow: '0 8px 20px -4px rgba(234, 88, 12, 0.5), inset 0 1px 1px rgba(255,255,255,0.2)', transition: 'all 0.2s', fontSize: '1rem' }} onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'} onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>
                OK, Add All
              </button>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          details.plan-card-item > summary { list-style: none; }
          details.plan-card-item > summary::-webkit-details-marker { display: none; }
          details.plan-card-item > summary .custom-arrow { transform: rotate(-90deg); transition: transform 0.2s ease; }
          details.plan-card-item[open] > summary .custom-arrow { transform: rotate(0deg); }
        `}
      </style>
      <button
        onClick={() => navigate('/admin')}
        style={{
          display: 'flex', alignItems: 'center', gap: '8px',
          backgroundColor: '#fff', border: '1px solid #ddd', padding: '10px 20px',
          borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', color: '#2c3e50',
          marginBottom: '20px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
          transition: 'all 0.3s ease'
        }}
        onMouseOver={(e) => e.currentTarget.style.transform = 'translateX(-5px)'}
        onMouseOut={(e) => e.currentTarget.style.transform = 'translateX(0)'}
      >
        <FaArrowLeft /> Back to Admin
      </button>

      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ fontSize: '2.8rem', color: '#2c3e50', fontWeight: '900', marginBottom: '10px' }}>
          Plan Customization
        </h1>
        <p style={{ fontSize: '1.1rem', color: '#7f8c8d', maxWidth: '700px', margin: '0 auto' }}>
          Edit prices dynamically. Drag full modules or individual pages into a plan to automatically build the subscription tier!
        </p>
      </div>

      <div style={{ display: 'flex', gap: '30px', alignItems: 'stretch' }}>

        {/* Left Side: Dynamic Blueprint (Palette) */}
        <div
          style={{
            flex: '0 0 380px',
            backgroundColor: '#fff',
            borderRadius: '20px',
            padding: '25px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.05)'
          }}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e, 'available')} // Trash zone basically
        >
          <h2 style={{ fontSize: '1.4rem', color: '#34495e', borderBottom: '2px solid #ecf0f1', paddingBottom: '15px', marginBottom: '20px' }}>
            Modules & Pages Palette
          </h2>
          <p style={{ fontSize: '0.85rem', color: '#95a5a6', marginBottom: '20px' }}>
            * Drag a module or expand it to drag specific pages. Edit prices below.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {availableModules.map(mod => (
              <div key={mod.id} style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>

                {/* Parent Module Row */}
                <div
                  draggable
                  onDragStart={(e) => handleDragStart(e, { id: mod.id, name: mod.name, price: mod.price, isParent: true, pages: mod.pages }, 'available')}
                  style={{
                    backgroundColor: '#f8fcff', border: '1px solid #d4e6f1', padding: '10px 15px',
                    borderRadius: '12px', cursor: 'grab', display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.borderColor = '#3498db'}
                  onMouseOut={(e) => e.currentTarget.style.borderColor = '#d4e6f1'}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div onClick={() => toggleExpand(mod.id)} style={{ cursor: 'pointer', color: '#7f8c8d', padding: '5px' }}>
                      {mod.isExpanded ? <FaChevronDown /> : <FaChevronRight />}
                    </div>
                    <FaGripVertical style={{ color: '#bdc3c7' }} />
                    <span style={{ fontWeight: '700', color: '#2c3e50', fontSize: '0.95rem' }}>{mod.name}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <span style={{ fontWeight: 'bold', color: '#2980b9' }}>$</span>
                    <input
                      type="number"
                      value={mod.price || ''}
                      readOnly={true}
                      style={{ width: '50px', padding: '5px', borderRadius: '5px', border: '1px solid #bdc3c7', textAlign: 'center', fontWeight: 'bold', color: '#2980b9', backgroundColor: '#eef2f5', cursor: 'not-allowed' }}
                    />
                  </div>
                </div>

                {/* Children Pages */}
                {mod.isExpanded && (
                  <div style={{ paddingLeft: '35px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {mod.pages.map(page => (
                      <div
                        key={page.id}
                        draggable
                        onDragStart={(e) => handleDragStart(e, { id: page.id, name: page.name, price: page.price, isParent: false, parentName: mod.name }, 'available')}
                        style={{
                          backgroundColor: '#fff', border: '1px dashed #bdc3c7', padding: '8px 12px',
                          borderRadius: '8px', cursor: 'grab', display: 'flex', justifyContent: 'space-between',
                          alignItems: 'center', transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fdfefe'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <FaGripVertical style={{ color: '#ecf0f1', fontSize: '0.8rem' }} />
                          <span style={{ color: '#34495e', fontSize: '0.85rem', fontWeight: '600' }}>{page.name}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <span style={{ color: '#27ae60', fontSize: '0.8rem' }}>$</span>
                          <input
                            type="number"
                            value={page.price || ''}
                            onChange={(e) => handlePriceChange(mod.id, page.id, e.target.value)}
                            style={{ width: '45px', padding: '3px', borderRadius: '4px', border: '1px solid #ddd', textAlign: 'center', fontSize: '0.85rem', color: '#27ae60' }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <button
            onClick={handleSavePalette}
            style={{
              marginTop: '25px', padding: '15px', width: '100%',
              borderRadius: '12px', border: 'none',
              backgroundColor: '#34495e',
              color: '#fff',
              fontWeight: 'bold', fontSize: '1.1rem', cursor: 'pointer',
              boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            Save Palette Config
          </button>
        </div>

        {/* Right Side: Subscription Plans Drop Zones */}
        <div style={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '25px' }}>
          {basePlans.map((plan, idx) => {
            const currentPrice = getPlanPrice(plan.name, plan.basePrice);
            const addedItems = planItems[plan.name];

            return (
              <div
                key={idx}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={(e) => handleDrop(e, plan.name)}
                style={{
                  background: plan.bg,
                  borderRadius: '20px',
                  border: `2px solid ${plan.border}`,
                  padding: '30px',
                  boxShadow: '0 10px 20px rgba(0,0,0,0.05)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {/* Plan Header */}
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  {plan.featured && (
                    <span style={{
                      position: 'absolute', top: '-45px', right: '50%', transform: 'translateX(50%)',
                      backgroundColor: '#e74c3c', color: '#fff', padding: '5px 15px',
                      borderRadius: '20px', fontSize: '0.8rem', fontWeight: 'bold',
                      boxShadow: '0 4px 10px rgba(231, 76, 60, 0.3)'
                    }}>
                      MOST POPULAR
                    </span>
                  )}
                  <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{plan.icon}</div>
                  <h2 style={{ fontSize: '1.6rem', color: plan.headerColor, fontWeight: '900', margin: '0 0 5px 0' }}>{plan.name}</h2>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', gap: '5px', marginBottom: '15px' }}>
                    <span style={{ fontSize: '2.8rem', color: '#2c3e50', fontWeight: '900' }}>${currentPrice}</span>
                    <span style={{ fontSize: '1.2rem', color: '#7f8c8d', fontWeight: 'bold' }}>/mo</span>
                  </div>
                  <p style={{ color: '#34495e', lineHeight: '1.5', fontSize: '0.95rem', margin: '0 0 20px 0', minHeight: '50px' }}>
                    {plan.desc}
                  </p>
                </div>

                {/* Configuration Inputs */}
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  padding: '15px',
                  borderRadius: '12px',
                  marginBottom: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                    <span style={{ fontSize: '0.9rem', color: '#34495e', fontWeight: 'bold' }}>Pricing Tiers</span>
                    <button
                      onClick={() => {
                        setPlanConfigs(prev => {
                          const tiers = prev[plan.name]?.pricingTiers || [];
                          return {
                            ...prev,
                            [plan.name]: { ...prev[plan.name], pricingTiers: [...tiers, { durationMonths: 12, label: '1 Year', discountAmount: 0 }] }
                          };
                        });
                      }}
                      style={{ background: '#3498db', color: '#fff', border: 'none', borderRadius: '4px', padding: '4px 8px', fontSize: '0.75rem', cursor: 'pointer' }}
                    >+ Add Tier</button>
                  </div>

                  {(planConfigs[plan.name]?.pricingTiers || []).map((tier, tIdx) => (
                    <div key={tIdx} style={{ display: 'flex', gap: '5px', alignItems: 'center', background: '#f8f9fa', padding: '8px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <input
                        type="text"
                        placeholder="Label (e.g. 1 Year)"
                        value={tier.label}
                        onChange={(e) => {
                          setPlanConfigs(prev => {
                            const newTiers = [...(prev[plan.name]?.pricingTiers || [])];
                            newTiers[tIdx] = { ...newTiers[tIdx], label: e.target.value };
                            return { ...prev, [plan.name]: { ...prev[plan.name], pricingTiers: newTiers } };
                          });
                        }}
                        style={{ width: '80px', padding: '4px', fontSize: '0.8rem', borderRadius: '4px', border: '1px solid #cbd5e1' }}
                      />
                      <input
                        type="number"
                        placeholder="Months"
                        title="Duration (Months)"
                        value={tier.durationMonths}
                        onChange={(e) => {
                          setPlanConfigs(prev => {
                            const newTiers = [...(prev[plan.name]?.pricingTiers || [])];
                            newTiers[tIdx] = { ...newTiers[tIdx], durationMonths: e.target.value };
                            return { ...prev, [plan.name]: { ...prev[plan.name], pricingTiers: newTiers } };
                          });
                        }}
                        style={{ width: '50px', padding: '4px', fontSize: '0.8rem', borderRadius: '4px', border: '1px solid #cbd5e1' }}
                      />
                      <input
                        type="number"
                        placeholder="Discount"
                        title="Discount Amount ($)"
                        value={tier.discountAmount}
                        onChange={(e) => {
                          setPlanConfigs(prev => {
                            const newTiers = [...(prev[plan.name]?.pricingTiers || [])];
                            newTiers[tIdx] = { ...newTiers[tIdx], discountAmount: e.target.value };
                            return { ...prev, [plan.name]: { ...prev[plan.name], pricingTiers: newTiers } };
                          });
                        }}
                        style={{ width: '70px', padding: '4px', fontSize: '0.8rem', borderRadius: '4px', border: '1px solid #cbd5e1' }}
                      />
                      <button
                        onClick={() => {
                          setPlanConfigs(prev => {
                            const newTiers = [...(prev[plan.name]?.pricingTiers || [])];
                            newTiers.splice(tIdx, 1);
                            return { ...prev, [plan.name]: { ...prev[plan.name], pricingTiers: newTiers } };
                          });
                        }}
                        style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: '4px', padding: '2px 6px', fontSize: '0.7rem', cursor: 'pointer' }}
                      >x</button>
                    </div>
                  ))}
                  {(planConfigs[plan.name]?.pricingTiers || []).length === 0 && (
                    <div style={{ fontSize: '0.8rem', color: '#7f8c8d', fontStyle: 'italic', textAlign: 'center' }}>No custom tiers added. Default is monthly.</div>
                  )}
                </div>

                {/* Drop Zone for Modules/Pages */}
                <div style={{
                  flex: 1,
                  backgroundColor: 'rgba(255, 255, 255, 0.6)',
                  borderRadius: '15px',
                  padding: '15px',
                  border: '2px dashed #bdc3c7',
                  minHeight: '250px'
                }}>
                  <h4 style={{ margin: '0 0 15px 0', color: '#7f8c8d', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'center' }}>
                    Included Features
                  </h4>

                  {addedItems.length === 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyItems: 'center', height: '150px', color: '#95a5a6', textAlign: 'center', paddingTop: '40px' }}>
                      <FaPlus style={{ fontSize: '2rem', marginBottom: '10px', opacity: 0.5 }} />
                      <span>Drag modules or specific pages here</span>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      {addedItems.map((item, idx) => (
                        <div
                          key={item.id}
                          style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}
                          onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); e.currentTarget.style.opacity = '0.5'; }}
                          onDragLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
                          onDrop={(e) => { e.currentTarget.style.opacity = '1'; handleDrop(e, plan.name, idx); }}
                        >
                          <details
                            className="plan-card-item"
                            style={{
                              backgroundColor: '#fff',
                              borderRadius: '10px',
                              boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
                              borderLeft: item.isParent ? '4px solid #3498db' : '4px solid #2ecc71',
                              overflow: 'hidden'
                            }}
                          >
                            <summary
                              draggable
                              onDragStart={(e) => handleDragStart(e, item, plan.name)}
                              style={{
                                padding: '12px 15px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                cursor: 'grab',
                                outline: 'none'
                              }}
                            >
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {item.isParent && <FaChevronDown className="custom-arrow" style={{ color: '#7f8c8d', fontSize: '0.8rem' }} />}
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <span style={{ fontWeight: '600', color: '#2c3e50', fontSize: '0.9rem' }}>{item.name}</span>
                                  {!item.isParent && <span style={{ fontSize: '0.7rem', color: '#95a5a6' }}>Sub-page of {item.parentName}</span>}
                                </div>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <span style={{ color: item.isParent ? '#2980b9' : '#27ae60', fontWeight: 'bold', fontSize: '0.85rem' }}>+${item.price}</span>
                                <button
                                  onClick={(e) => { e.preventDefault(); handleRemoveFromPlan(item.id, plan.name); }}
                                  style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', padding: '5px' }}
                                  title="Remove"
                                >
                                  <FaTimes />
                                </button>
                              </div>
                            </summary>

                            {/* If the dragged item is a parent and has pages, render them as sub-items */}
                            {item.isParent && item.pages && item.pages.length > 0 && (
                              <div style={{ paddingLeft: '30px', paddingRight: '15px', paddingBottom: '12px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                {item.pages.map(page => (
                                  <div key={page.id} style={{
                                    backgroundColor: 'rgba(255,255,255,0.6)', padding: '6px 12px', borderRadius: '6px',
                                    borderLeft: '2px dashed #bdc3c7', display: 'flex', justifyContent: 'space-between',
                                    alignItems: 'center', fontSize: '0.8rem'
                                  }}>
                                    <span style={{ color: '#34495e' }}>{page.name}</span>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <span style={{ color: '#7f8c8d', fontWeight: '600' }}>+${page.price || 0}</span>
                                      <button
                                        onClick={(e) => { e.preventDefault(); handleRemovePageFromPlan(plan.name, item.id, page.id); }}
                                        style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', padding: '0 5px' }}
                                        title="Remove Sub-page"
                                      >
                                        <FaTimes />
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </details>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <button
                  onClick={() => handleSavePlan(plan.name)}
                  style={{
                    marginTop: '25px', padding: '15px', width: '100%',
                    borderRadius: '12px', border: 'none',
                    backgroundColor: plan.headerColor,
                    color: '#fff',
                    fontWeight: 'bold', fontSize: '1.1rem', cursor: 'pointer',
                    boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  Save {plan.name} Config
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RestaurantPlan;
